<template>
  <el-card class="panel-card" shadow="never">
    <template #header>
      <div class="card-header">
        <span>生成 API Key</span>
      </div>
    </template>
    <el-form class="inline-form" label-position="top" @submit.prevent>
      <el-form-item label="额度">
        <el-input-number v-model="quota" :min="1" :step="100" controls-position="right" />
      </el-form-item>
      <el-form-item label="过期时间">
        <el-date-picker
          v-model="expiresAt"
          type="datetime"
          format="YYYY-MM-DD HH:mm:ss"
          value-format="YYYY-MM-DD HH:mm:ss"
          placeholder="YYYY-MM-DD HH:mm:ss"
        />
      </el-form-item>
      <el-button type="primary" :loading="loading" @click="submit">生成</el-button>
    </el-form>
    <el-alert v-if="notice" class="notice-alert" :title="notice" type="success" show-icon :closable="false" />
  </el-card>
</template>

<script>
function defaultExpiresAt() {
  const date = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000)
  const pad = (value) => String(value).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
}

export default {
  name: 'CreateKeySection',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    notice: {
      type: String,
      default: ''
    }
  },
  emits: ['create'],
  data() {
    return {
      quota: 100,
      expiresAt: defaultExpiresAt()
    }
  },
  methods: {
    submit() {
      this.$emit('create', {
        quota: this.quota,
        expires_at: this.expiresAt
      })
    }
  }
}
</script>
